import { defaultAxios, IParams } from './base';

export interface IPutLoanChange extends IParams {
  requestSeq?: string;
}

export const putLoanChange = (params: IPutLoanChange) => {
  return defaultAxios().put(`/loan/changeLoan`, params);
};
